"use client"


import { Plane, MapPin, Clock, Shield, Users, Zap } from "lucide-react"
import { Helmet } from 'react-helmet-async';
import logo from '../../asset/logo.jpg'
import FlightBookingForm from "../FlightBookingForm";
function FlightsContent() {
  const features = [
    {
      icon: Plane,
      title: "Global Network",
      description: "Access to 500+ airlines covering destinations across all continents",
    },
    {
      icon: MapPin,
      title: "Worldwide Coverage",
      description: "Book flights to over 10,000 airports worldwide at competitive rates",
    },
    
    {
      icon: Users,
      title: "Expert Support",
      description: "24/7 travel consultants ready to assist with flight planning",
    },
    
  ]

  return (
    <div className="min-h-screen bg-background">
 
<Helmet>
  <title>Flights — YS Sky Travel and Tour Agency P.L.C</title>
  <meta name="description" content="Book flights worldwide with competitive fares and support." />
</Helmet>

      {/* Hero */}
     
<section className="relative h-72 bg-gradient-to-r from-primary-900 via-medical-600 to-blue-600 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={logo}
            alt="Contact us"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-medical-600/60"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-center w-full animate-fade-in">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
        Airplane Tickets
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
         Your gateway to the world with unbeatable flight deals
            </p>
          </div>
        </div>

        {/* Animated Elements */}
        <div className="absolute top-20 right-20 w-32 h-32 bg-white/10 rounded-full animate-float"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-white/10 rounded-full animate-float" style={{ animationDelay: '2s' }}></div>
      </section>
      {/* Service Overview */}
      <section className=" px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-card border border-border rounded-2xl p-8 mb-16">
            <h2 className="text-3xl font-bold mb-6 text-primary">About Our Airplane Ticket Service</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>
                At YS Sky Travel and Tour Agency PLC , we help you find and book the best flight tickets easily and at affordable prices. We work with many airlines worldwide to give you good options at competitive rates, all in one place.
              </p>
              <p>
               Whether you are traveling for holiday, business, or family reasons, our team will choose the best flights based on your budget and schedule. We arrange both international and domestic flights with clear pricing and no hidden charges.
              </p>
             <p>
               Contact us on WhatsApp to book your flights quickly and easily.
              </p>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-10 text-primary">Why Choose Our Airplane Ticket Service</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feature, idx) => {
                const Icon = feature.icon
                return (
                  <div
                    key={idx}
                    className="bg-card border border-border rounded-xl p-6 hover:border-accent transition-colors"
                  >
                    <Icon className="w-10 h-10 text-accent mb-4" />
                    <h3 className="font-bold text-lg mb-2">{feature.title}</h3>
                    <p className="text-muted-foreground text-sm">{feature.description}</p>
                  </div>
                )
              })}
            </div>
          </div>

          {/* Service Details */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl p-8 border border-primary/20">
              <h3 className="text-2xl font-bold mb-4 text-primary">Flight Types We Cover</h3>
              <ul className="space-y-3">
                {[
                  "Economy Class - Budget-friendly flights with essential amenities",
                  "Premium Economy - Enhanced comfort with extra space and services",
                  "Business Class - Luxury travel with premium meals and entertainment",
                  "First Class - Ultimate luxury experience with exclusive perks",
                  "Round-trip Flights - Complete journey planning and booking",
                  "One-way Flights - Flexible travel for explorers",
                ].map((item, idx) => (
                  <li key={idx} className="flex gap-3 items-start">
                    <Plane className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" />
                    <span className="text-foreground">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-gradient-to-br from-accent/10 to-primary/10 rounded-2xl p-8 border border-accent/20">
              <h3 className="text-2xl font-bold mb-4 text-primary">Our Promise to You</h3>
              <ul className="space-y-3">
                {[
                  "Best Price Guarantee - We match or beat competitor prices",

                  "Expert Guidance - Professional advice for every journey",
                  "Flexible Modifications - Change or cancel with ease",
                 
                  "Multi-City Bookings - Complex itineraries made simple",
                ].map((item, idx) => (
                  <li key={idx} className="flex gap-3 items-start">
                    <Shield className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" />
                    <span className="text-foreground">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

        
        </div>
      </section>
<FlightBookingForm/>
   
    </div>
    
  )
}

export default function Flights() {
  return (
 
      <FlightsContent />
    
  )
}
